export enum ContentType {
  Article = "ARTICLE",
  Audio = "AUDIO",
  Video = "VIDEO",
}

export enum SortBy {
  PublishedDate = "PUBLISHED_DATE",
  SavedDate = "SAVED_DATE",
}

export enum SortOrder {
  Asc = "ASC",
  Desc = "DESC",
}
